import EventBus from '../../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'
import '../../../../shared/js/components/form-validation'
import '../../../../shared/js/components/modals'

class CancelReasonModal {
    
    /**
     * Construct module
     * @param template
    */
    constructor(template) {
        
        /**
         * Comment jQuery object
         * @type object
        */
        this.comment = null
        
        /**
         * Modal container jQuery object
         * @type object
        */
        this.container = null
        
        /**
         * Form jQuery object
         * @type object
        */
        this.form = null
        
        /**
         * Select input jQuery object
         * @type object
        */
        this.select = null
        
        /**
         * Submit button jQuery object
         * @type object
        */
        this.submitBtn = null
        
        /**
         * Form template jQuery element
         * @type object
        */
        this.template = template
        
        this.bindEvents()
        
    }
    
    /**
     * Run module
    */
    run() {
        
        //Open modal
        EventBus.publish('create-modal', {
            body: this.template.html(),
            callback: this.modalOpened.bind(this),
            header: '<p class="h3">Why did you cancel?</p>',
            footer: `
                <button type="button" class="btn btn-link text-dark" data-dismiss="modal">
                    <i aria-hidden="true" class="icon-cancel"></i>
                    Close
                </button>
                <button type="button" class="btn btn-primary submit">
                    Submit
                </button>
            `,
            footerClasses: 'bg-light justify-content-between',
            size: 'md'
        })
        
    }
    
    /**
     * Modal opened
     * @param modal
    */
    modalOpened(modal) {
        
        this.comment = jQuery('#cancel-reason-text')
        this.container = modal
        this.form = this.container.find('form')
        this.select = jQuery('#cancel-reason-select')
        this.submitBtn = jQuery(this.container.find('.submit'))
        
        //Initialise validation on form
        EventBus.publish('validation.setup', this.form)
        
        //Bind submit button press
        this.submitBtn.click(() => {
            
            if (this.form.hasClass('loading') || this.submitBtn.prop('disabled')) {
                return
            }
            
            this.form.submit()
            
        })
        
        //Bind select change
        this.select.change(this.selectChanged.bind(this))
        
        //Bind form success
        this.form.on('form-ajax-success', () => {
            this.form.hide()
            this.submitBtn.prop('disabled', true)
            jQuery('#cancel-reason-thanks').show()
        })
        
    }
    
    /**
     * Select input changed
    */
    selectChanged() {
        
        //Show other
        if (this.select.val() == 'other') {
            this.comment.prop('disabled', false).parent().show()
            return
        }
        
        //Hide other
        this.comment.prop('disabled', true).parent().hide()
        
    }
    
    /**
     * Bind event listeners
    */
    bindEvents() {
        
        //Run module
        EventBus.subscribe('run-modules', this.run.bind(this))
      
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    const template = jQuery('#cancel-reason-template')
    
    if (template.length > 0) {
        new CancelReasonModal(template)
    }
    
})

export default CancelReasonModal